import { useEffect, useState } from 'react';
import { api } from '../lib/api';

const POLL_INTERVAL_MS = 20 * 1000;

export function useLiveReaderCount() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    const fetchCount = () => {
      api.get('/presence/count')
        .then((data) => { if (!cancelled) setCount(data.count); })
        .catch(() => {});
    };

    fetchCount();
    const interval = setInterval(fetchCount, POLL_INTERVAL_MS);
    return () => { cancelled = true; clearInterval(interval); };
  }, []);

  return count;
}
